import { useTheme } from '@emotion/react'
import { AddBtn, AddBtnContainer } from './add-button.styles'

interface AddButtonProps {
  label: string
  handleClick: () => void
}

const AddButton = ({ label, handleClick }: AddButtonProps) => {
  const theme = useTheme()

  return (
    <AddBtnContainer>
      <AddBtn theme={theme} onClick={handleClick}>
        {label}
      </AddBtn>
    </AddBtnContainer>
  )
}

export default AddButton
